module.exports = __webpack_public_path__ + "static/artboard_5-c2dfacdeccf77c49fff7b36553d0eab6.svg";